module.exports = __webpack_public_path__ + "media/src/images/icons/privacy/blue-23d8581685d364d61ee77ec18c65e2db.svg";